import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon } from 'semantic-ui-react';
import { SearchBar, USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

const WebFormsToolbar = ({ onChange, value, onReadFilters, isReadingWebForms, onClearSearch }) => {
    return (
        <div className='WebFormsToolbar'>
            <SearchBar
                onChange={onChange}
                isSearching={isReadingWebForms}
                search={value}
                searchFcn={onReadFilters}
                cancelFcn={onClearSearch}
                placeholder={'Search by Internal Form Name'}
                bottomError
            />

        <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.WEB_FORMS_ADD}>
            <Button as={Link} to="/settings/web-forms/create" className='WebFormsToolbar__NewWebFormButton' ><Icon name='plus' /> New Web Form</Button>
        </RestrictedView>
        </div>
    )
}

export default WebFormsToolbar;
